import { Chain, Currency } from '../enums';

export interface ChainConfig {
  chain: Chain;
  name: string;
  chainId?: number;
  isEvm: boolean;
  rpcUrl: string;
  explorerUrl: string;
  tokens: Record<Currency, string>;
}

export const CHAIN_CONFIGS: Record<Chain, ChainConfig> = {
  [Chain.ETHEREUM]: {
    chain: Chain.ETHEREUM,
    name: 'Ethereum',
    chainId: 1,
    isEvm: true,
    rpcUrl: 'https://eth-mainnet.g.alchemy.com/v2/',
    explorerUrl: 'https://etherscan.io',
    tokens: {
      [Currency.USDC]: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
      [Currency.USDT]: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    },
  },
  [Chain.POLYGON]: {
    chain: Chain.POLYGON,
    name: 'Polygon',
    chainId: 137,
    isEvm: true,
    rpcUrl: 'https://polygon-mainnet.g.alchemy.com/v2/',
    explorerUrl: 'https://polygonscan.com',
    tokens: {
      [Currency.USDC]: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359',
      [Currency.USDT]: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
    },
  },
  [Chain.BASE]: {
    chain: Chain.BASE,
    name: 'Base',
    chainId: 8453,
    isEvm: true,
    rpcUrl: 'https://base-mainnet.g.alchemy.com/v2/',
    explorerUrl: 'https://basescan.org',
    tokens: {
      [Currency.USDC]: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
      [Currency.USDT]: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
    },
  },
  [Chain.SOLANA]: {
    chain: Chain.SOLANA,
    name: 'Solana',
    isEvm: false,
    rpcUrl: 'https://mainnet.helius-rpc.com/?api-key=',
    explorerUrl: 'https://solscan.io',
    tokens: {
      [Currency.USDC]: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
      [Currency.USDT]: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
    },
  },
};

export const EVM_CHAINS = [Chain.ETHEREUM, Chain.POLYGON, Chain.BASE] as const;
export const isEvmChain = (chain: Chain): boolean => CHAIN_CONFIGS[chain].isEvm;
